import React, { FC, useMemo } from 'react'
import styles from 'styles/components/list.module.scss'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getSpecialHolidays } from 'reducks/calendar/selectors'
import format from 'date-fns/format'
import { SpecialHolidayType } from 'types/calendar'
import { CalendarListItem } from 'components/List'

const CalendarList: FC = () => {
  const specialHolidays: SpecialHolidayType[] = useSelector((state: State) => getSpecialHolidays(state))

  // 祝日が設定されている年を取得する
  const years = useMemo(() => {
    const thisYear = format(new Date(), 'yyyy')
    if (!specialHolidays) return [thisYear]

    const _years = specialHolidays.reduce(
      (prev, specialHoliday) => {
        const year = specialHoliday.date.slice(0, 4)
        return prev.includes(year) ? prev : [...prev, year]
      },
      [thisYear] as string[]
    )

    // 昇順でソート
    return _years.sort((a, b) => (a < b ? -1 : 1))
  }, [specialHolidays])

  return (
    <ul className={styles.calendar}>
      {years.map((year) => {
        const specialHolidaysInTheYear = specialHolidays.filter((specialHoliday) => {
          return specialHoliday.date.slice(0, 4) === year
        })

        return <CalendarListItem key={year} specialHolidays={specialHolidaysInTheYear} year={year} />
      })}
    </ul>
  )
}

export default CalendarList
